<template>
  <article class="content mini-rounded">
    <h2 class="h2 is-size-4 title is-uppercase">
      <span
        v-if="icon"
        class="icon"
        :class="[iconColor ? iconColor : 'has-text-white']"
      >
        <i :class="[icon]"></i>
      </span>
      <slot name="title"></slot>
    </h2>
    <h3 class="h3 subtitle is-size-5">
      <slot name="subtitle"></slot>
    </h3>

    <slot name="description"></slot>
  </article>
</template>

<script>
export default {
  components: {},
  props: ["icon", "iconColor"],
  data() {
    return {
      showMore: false,
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
